<template>
  <div>
    <v-stepper-step :complete="currentStep > 4" step="4">
      <h3>WHO ARE YOU?</h3>
      <div v-show="currentStep == 4" class="text-caption">
        <p>
          <span class="red--text"><strong>* </strong></span>= Mandatory field
        </p>
      </div>
    </v-stepper-step>
    <v-stepper-content step="4">
      <v-form v-model="senderFormValid">
        <v-row>
          <v-col cols="12" md="6">
            <v-text-field
              class="hasValidationErrorIcon"
              prepend-inner-icon="mdi-information-outline"
              v-model="sender.name"
              :rules="nameRules"
              :counter="14"
              label="First Name"
              placeholder="First Name"
              required
            >
              <template #label>
                <h3 class="black--text">
                  <span class="red--text"><strong>* </strong></span>FIRST NAME:
                </h3>
              </template>
            </v-text-field>
          </v-col>

          <v-col cols="12" md="6">
            <v-text-field
              class="hasValidationErrorIcon"
              prepend-inner-icon="mdi-information-outline"
              v-model="sender.surname"
              :rules="lastNameRules"
              :counter="20"
              label="Last Name"
              placeholder="Last Name"
              required
            >
              <template #label>
                <h3 class="black--text">
                  <span class="red--text"><strong>* </strong></span>LAST NAME:
                </h3>
              </template>
            </v-text-field>
          </v-col>
        </v-row>
        <template>
          <v-subheader class="pl-0">
            Search for your address using the address finder or enter it
            manually below.
          </v-subheader>
          <v-card class="mb-4">
            <v-card-text class="py-0">
              <v-autocomplete
                v-model="selectedAddress"
                input="selectedAddress"
                :items="items"
                :loading="isLoadingAddressData"
                :search-input.sync="search"
                :menu-props="autocompleteMenuProps"
                hide-no-data
                item-text="Description"
                placeholder="Search by Postcode, Locality, House number, House name, etc..."
                prepend-icon="mdi-magnify"
                return-object
              ></v-autocomplete>
            </v-card-text>
          </v-card>
        </template>
        <v-row>
          <v-col cols="12" md="12">
            <v-text-field
              class="hasValidationErrorIcon"
              prepend-inner-icon="mdi-information-outline"
              v-model="sender.addressLine1"
              :rules="addressLine1Rules"
              label="Address Line 1"
              placeholder="Address Line 1"
              :counter="50"
              required
            >
              <template #label>
                <h3 class="black--text">
                  <span class="red--text"><strong>* </strong></span>ADDRESS LINE
                  1:
                </h3>
              </template>
            </v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="12">
            <v-text-field
              v-model="sender.addressLine2"
              label="Address Line 2"
              placeholder="Address Line 2"
              :counter="50"
              :rules="addressLine2Rules"
            >
              <template #label>
                <h3 class="black--text">ADDRESS LINE 2:</h3>
              </template></v-text-field
            >
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="4">
            <v-text-field
              class="hasValidationErrorIcon"
              prepend-inner-icon="mdi-information-outline"
              v-model="sender.postcode"
              :rules="postcodeRules"
              label="Post Code"
              placeholder="Post Code"
              :counter="17"
              required
            >
              <template #label>
                <h3 class="black--text">
                  <span class="red--text"><strong>* </strong></span>POST CODE:
                </h3>
              </template>
            </v-text-field>
          </v-col>

          <v-col cols="12" md="4">
            <v-text-field
              class="hasValidationErrorIcon"
              prepend-inner-icon="mdi-information-outline"
              v-model="sender.locality"
              :rules="localityRules"
              :counter="35"
              label="Locality"
              placeholder="Locality"
              required
            >
              <template #label>
                <h3 class="black--text">
                  <span class="red--text"><strong>* </strong></span>LOCALITY:
                </h3>
              </template>
            </v-text-field>
          </v-col>

          <v-col cols="12" md="4">
            <v-text-field
              readonly
              disabled
              hide-details
              label="COUNTRY"
              class="sender-country"
              v-model="sender.countryName"
            >
              <template #label>
                <h3 class="black--text">
                  COUNTRY:
                </h3>
              </template>
            </v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="4">
            <v-text-field
              class="hasValidationErrorIcon"
              prepend-inner-icon="mdi-information-outline"
              v-model="sender.email"
              :rules="emailRules"
              :counter="50"
              label="E-mail"
              placeholder="E-mail"
            >
              <template #label>
                <h3 class="black--text">E-MAIL:</h3>
              </template></v-text-field
            >
          </v-col>

          <v-col cols="12" md="4">
            <v-text-field
              v-model="sender.phone"
              :rules="phoneRules"
              :counter="20"
              label="Phone"
              placeholder="Phone"
            >
              <template #label>
                <h3 class="black--text">PHONE:</h3>
              </template></v-text-field
            >
          </v-col>

          <v-col cols="12" md="4" v-if="recipientCountry && !recipientCountry.requireVOEC">
            <v-text-field 
              v-model="sender.vatNumber" 
              :rules="vatNumberSenderRules" 
              :counter="10" 
              label="VAT Number"
              placeholder="VAT Number"
            >
              <template #label>
                <h3 class="black--text">VAT NUMBER:</h3>
              </template></v-text-field>
          </v-col>

          <v-col cols="12" md="4" v-if="recipientCountry && recipientCountry.requireVOEC">
            <v-text-field 
              v-model="sender.voecNumber" 
              :rules="voecNumberSenderRules" 
              :counter="7" 
              label="VOEC Number"
              placeholder="VOEC Number"
            >
              <template #label>
                <h3 class="black--text">VOEC NUMBER:</h3>
              </template></v-text-field>
          </v-col>
        </v-row>
      </v-form>
      <v-btn color="primary" @click="goNext()" :disabled="!senderFormValid">
        Next
      </v-btn>
      <v-btn text @click="goBack()"> Back </v-btn>
    </v-stepper-content>

    <v-dialog v-model="showVOECDialog" max-width="400">
      <v-card>
        <v-card-title>VOEC Number</v-card-title>
        <v-card-text>For items going to Norway, we recommend populating the VOEC number field.</v-card-text>
        <v-card-actions>
          <v-btn color="primary" block @click="voecDialogShown = true">Ok</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </div>
</template>

<script>
import validationRules from "../../helpers/ValidationRules";
import customsRules from "../../helpers/CustomsRules";
import axios from "axios";
import { combineURLs } from "../../helpers/UrlHelpers";
import { createNamespacedHelpers } from "vuex";
const { mapGetters: mapDeclarationGetters } = createNamespacedHelpers(
  "declarations"
);

export default {
  name: "Step04Sender",
  data() {
    return {
      sender: {
        name: "",
        surname: "",
        email: "",
        addressLine1: "",
        addressLine2: "",
        postcode: "",
        locality: "",
        countryId: null,
        countryName: "MALTA",
        phone: "",
        vatNumber: "",
        voecNumber: "",
      },
      addressSearchResults: [],
      search: null,
      selectedAddress: null,
      isLoadingAddressData: false,
      senderFormValid: false,
      voecDialogShown: false,
      ...validationRules,
    };
  },
  computed: {
    ...mapDeclarationGetters(["countries"]),
    currentStep: {
      set(currentStep) {
        this.$store.dispatch("declarations/setCurrentStep", currentStep);
      },
      get() {
        return this.$store.getters["declarations/currentStep"];
      },
    },
    items() {
      return this.addressSearchResults.map((entry) => {
        var addrLine1 = [
          entry.houseNo,
          entry.houseName,
          entry.houseAlpha,
          entry.flatNo,
        ]
          .join(" ")
          .trim();
        var Description =
          addrLine1 +
          ", " +
          entry.street +
          ", " +
          entry.locality +
          " " +
          entry.postCode +
          ", " +
          entry.country;
        return Object.assign({}, entry, { Description, addrLine1 });
      });
    },
    autocompleteMenuProps() {
      // default properties copied from the vuetify-autocomplete docs
      let defaultProps = {
        closeOnClick: false,
        closeOnContentClick: false,
        disableKeys: true,
        openOnClick: false,
        maxHeight: 304,
        offsetY: true,
        offsetOverflow: true,
        transition: false,
      };

      if (this.$vuetify.breakpoint.smAndDown) {
        defaultProps.maxHeight = 185;
      }

      return defaultProps;
    },
    recipientCountry: {
      get() {
        const recipientCountryId = this.$store.getters["declarations/Step01Recipient/countryId"];
        const recipientCountry = this.countries.find(function (country) { return country.id === recipientCountryId; });

        return recipientCountry;
      }
    },
    recipientCountryRequiresVoec: {
      get() {
        const recipientCountryId = this.$store.getters["declarations/Step01Recipient/countryId"];
        if (recipientCountryId) {
          const country = this.countries.find(function (country) {
            return country.id === recipientCountryId;
          });
          return country ? country.requireVOEC : false;
        }
        return false;
      }
    },
    showVOECDialog: {
      get() {
        if (this.currentStep != 4) {return false;}
        return this.recipientCountryRequiresVoec && !this.sender.voecNumber && !this.voecDialogShown;
      }
    }
  },
  watch: {
    search(val) {
      if (!val) {
        this.addressSearchResults = [];
      } else if (
        !this.isLoadingAddressData &&
        (this.selectedAddress == null ||
          val != this.selectedAddress.Description)
      ) {
        setTimeout(() => {
          /* Better to use new URL but that assumes the base URL has no relative part (e.g. http://.../api). 
            "new URL" will remove the relative part from the base URL. 
            In all our base URL variables there is a relative part. 
            We would need to change all URL variables (e.g. in .env, live.properties etc.).  
          */
          // var url = new URL(
          //   `/v1/address/search?query=${this.search}&maxresult=15`,
          //   process.env.VUE_APP_ADDRESS_FINDER_API_BASE_URL
          // ).href;
          var url = combineURLs(
            process.env.VUE_APP_ADDRESS_FINDER_API_BASE_URL,
            `/v1/address/search?query=${this.search}&maxresult=15`
          );
          axios
            .get(url)
            .then((res) => {
              this.addressSearchResults = res.data;
            })
            .catch((err) => {
              console.log(err);
              this.addressSearchResults = [];
            })
            .finally(() => (this.isLoadingAddressData = false));
        }, 1500);

        this.isLoadingAddressData = true;
      }
    },
    selectedAddress(newSelectedAddress) {
      if (newSelectedAddress != null) {
        this.sender.addressLine1 = newSelectedAddress.addrLine1;
        this.sender.addressLine2 = newSelectedAddress.street;
        this.sender.locality = newSelectedAddress.locality;
        this.sender.postcode = newSelectedAddress.postCode;

        var selectedCountry = this.countries.find(function (country) {
          return (
            country.name.toUpperCase() ===
            newSelectedAddress.country.toUpperCase()
          );
        });

        if (selectedCountry) {
          this.sender.countryId = selectedCountry.id;
        }
      }
    },
  },
  methods: {
    goBack() {
      const recipientCountryId = this.$store.getters[
        "declarations/Step01Recipient/countryId"
      ];
      const { stepNumber: backStep } = customsRules.beforeSenderGoTo(
        recipientCountryId,
        this.countries
      );

      this.voecDialogShown = false;
      this.currentStep = backStep;
    },
    goNext() {
      this.voecDialogShown = false;

      if (!this.sender.email && !this.sender.phone) {
        this.$store.dispatch("declarations/showRequiredEmailOrPhoneError");
      }
      else {
        this.$store.dispatch("declarations/Step04Sender/setSender", this.sender);
        this.$store.dispatch("declarations/setCurrentStep", 5);
      }
    },
  },
  mounted() {
    if (this.$store.state.declarations.keepSender) {
      this.sender = { ...this.$store.state.declarations.Step04Sender.sender };
    }

    //Watch out: countries are async loaded in the parent mounted function!
    //Maybe countries not available when this mounted function is called!
    const sender = this.sender;

    this.sender.countryId = this.countries?.find(function (country) {
      return country.name.toUpperCase() === sender?.countryName;
    })?.id;
  },
};
</script>

<style>

.sender-country.v-input--is-disabled input {
  color: rgba(0, 0, 0, 0.87);
}

.sender-country.v-text-field .v-input__control .v-input__slot:before,
.sender-country.v-text-field .v-input__control .v-input__slot:after,
.sender-country.v-text-field:not(.v-input--has-state):hover .v-input__control .v-input__slot:before {
  border: none;
}
</style>